import React, { useCallback } from 'react';
import SharedScript from '@americanexpress/shared-scripts';
import { useDDL } from '@americanexpress/react-ddl';
import { useMembershipData } from '../../hooks/useMembershipDataHook';
import { usePersonaApi } from '../../hooks/usePersonaApi';
import { getPersonaTypeFromPersona } from '../../utils/personaUtils';
import { getCardType, getTravelerIACode } from '../../utils/membershipDataUtils';
import { ROOT_MODULE_NAME } from '../../constants/modules';

const OneXP = () => {
  const { data: membershipData, isLoading: membershipLoading } = useMembershipData();
  const { data: personaData, isLoading: personaLoading } = usePersonaApi();
  const { getDDL, updateDDL } = useDDL();

  const configureVisualEditor = useCallback(() => {
    window.scriptConfig = window.scriptConfig || {};
    window.scriptConfig.visualEditorConfig = {
      ddl: {
        getDDL,
        updateDDL,
      },
      segmentation: async () => ({
        productId: getTravelerIACode(membershipData) || '',
        productFamily: getCardType(membershipData) || '',
        personaType: getPersonaTypeFromPersona(personaData) || '',
      }),
      applicationId: ROOT_MODULE_NAME,
    };
  }, [membershipData, personaData, getDDL, updateDDL]);

  if (!global.BROWSER || membershipLoading || personaLoading) {
    return null;
  }

  return (
    <>
      <SharedScript // allows use of the eXPress visual editor
        name="visual-editor-sdk"
        version="^2.4.0"
        async={true}
        windowCheck="veSDK"
        sideEffect={configureVisualEditor}
      />
      <SharedScript // adds tracking for eXPress experiments
        name="trackit"
        version="^1.14.0"
        async={true}
      />
    </>
  );
};

export default OneXP;
